import React from "react";
import { motion } from "framer-motion";
import { Phone, ShieldCheck, Clock } from "@phosphor-icons/react";
import EligibilityForm from "../components/EligibilityForm";
import { COMPANY } from "../lib/constants";

export default function Eligibility() {
  return (
    <div data-testid="eligibility-page">
      <section className="eco-gradient py-14 lg:py-18">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">
              Étude d'éligibilité
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight">
              Vérifiez votre éligibilité
              <br className="hidden md:block" />
              <span className="bg-gradient-to-r from-blue-700 to-emerald-600 bg-clip-text text-transparent">
                en quelques clics
              </span>
            </h1>
            <p className="text-slate-600 mt-4 max-w-2xl">
              Répondez à quelques questions rapides pour identifier les
              solutions énergétiques adaptées à votre logement. Sans engagement.
            </p>
          </motion.div>

          <div className="mt-6 flex flex-wrap gap-5 text-sm text-slate-600">
            <div className="flex items-center gap-2">
              <Clock size={16} className="text-blue-700" /> Moins de 2 minutes
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck size={16} className="text-emerald-600" /> Données confidentielles
            </div>
            <a
              href={COMPANY.phoneHref}
              data-testid="eligibility-header-call-btn"
              className="flex items-center gap-2 text-blue-700 font-semibold hover:text-blue-800"
            >
              <Phone size={16} weight="fill" /> Ou appeler : {COMPANY.phone}
            </a>
          </div>
        </div>
      </section>

      <section className="py-14 bg-slate-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <EligibilityForm />
          <p className="text-xs text-slate-500 text-center mt-6">
            Les informations renseignées sont traitées de manière confidentielle
            et utilisées uniquement pour étudier votre projet. Aides disponibles
            selon votre situation. Reste à charge variable selon profil.
          </p>
        </div>
      </section>
    </div>
  );
}
